import { Link } from "react-router-dom";

export const LoginPage = () =>{
  return (
    <>
      <p>login page</p>
      <Link to="/oauth/callback">link</Link>
    </>
  );
}